export const LOCAL_PASSWORD_MIN_LENGTH = 8;
export const LOCAL_PASSWORD_MAX_LENGTH = 128;
const COMMON_PASSWORDS = new Set([
    'password',
    'password1',
    'password12',
    'passw0rd',
    'qwertyui',
    'qwerty12',
    'qwerty123',
    'qwertyuiop',
    '1q2w3e4r',
    'abc12345',
    'abcdefgh',
    'iloveyou',
    'admin123',
    'admin1234',
    'welcome1',
    'changeme',
    'trustno1',
    'sunshine',
    'football',
    'baseball',
    'princess',
    'superman',
    '12312312',
    '12341234',
    '123456789012',
    '1234567890123',
    '123456789123',
    '123456789abc',
    '123123123123',
    '111111111111',
    '000000000000',
    'password1234',
    'password12345',
    'password123456',
    'passwordpassword',
    'passw0rd1234',
    'qwerty123456',
    'qwerty1234567',
    'qwerty123456789',
    'qwertyuiopas',
    'qwertyuiop12',
    '1q2w3e4r5t6y',
    'abcdefghijkl',
    'abc123456789',
    'iloveyou1234',
    'admin1234567',
    'letmein12345',
    'welcome12345',
    'changeme1234',
]);
const passwordLength = (password) => Array.from(password).length;
const isRepeatedCharacter = (password) => {
    const chars = Array.from(password);
    const first = chars[0];
    return chars.length > 0 && chars.every((char) => char === first);
};
const isDigitSequence = (password) => {
    if (!/^\d+$/.test(password))
        return false;
    const ascending = '0123456789'.repeat(13);
    const descending = '9876543210'.repeat(13);
    return ascending.includes(password) || descending.includes(password);
};
const sameIdentity = (password, value) => {
    if (typeof value !== 'string' || value.length === 0)
        return false;
    return password.toLowerCase() === value.toLowerCase();
};
/**
 * Правила нового локального пароля.
 * Вхідний рядок не змінюється: без trim і без обрізання.
 */
export const validateLocalPassword = (password, identity = {}) => {
    const length = passwordLength(password);
    if (length < LOCAL_PASSWORD_MIN_LENGTH)
        return 'too_short';
    if (length > LOCAL_PASSWORD_MAX_LENGTH)
        return 'too_long';
    const folded = password.toLowerCase();
    if (COMMON_PASSWORDS.has(folded) || isRepeatedCharacter(password) || isDigitSequence(password)) {
        return 'common';
    }
    if (sameIdentity(password, identity.email) || sameIdentity(password, identity.login)) {
        return 'matches_identity';
    }
    return null;
};
